<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Button } from '@shared/ui/buttons/button';
  import { Checkbox } from '@shared/ui/checkbox';
  import { Icon } from '@shared/ui/icon';
  import { Modal } from '@shared/ui/modal';
  import { Portal } from '@shared/ui/portal';

  export let isOpen: boolean = false;

  let isDisabled = true;

  const dispatch = createEventDispatcher<{
    confirm: void;
    close: void;
  }>();

  function handleConfirm() {
    dispatch('confirm');
  }

  function handleCheckboxChange() {
    isDisabled = !isDisabled;
  }

  function handleClose() {
    dispatch('close');
  }
</script>

<Portal>
  <Modal bind:open="{isOpen}" on:close="{handleClose}" hasFooter="{false}" showOutsideCloseButton>
    <div class="flex flex-col gap-5 pt-5">
      <h2 class="flex items-center gap-3 text-xl font-semibold">
        <Icon name="eye-slash" width="{32}" height="{32}" />Sensitive Content Warning
      </h2>
      <p class="dark:text-dark-800 text-base">
        Some artworks may contain content that is not suitable for all viewers.
      </p>
      <p class="dark:text-dark-800 text-base">
        To protect your audience, we apply a <strong class="dark:text-default-50">NSFW Filter</strong> to images flagged
        as containing:
        <br />
        <strong class="dark:text-default-50"
          >Nudity, pornography, profanity, slurs, graphic violence, or flashing hazards.</strong
        >
      </p>
      <Checkbox name="confirm" on:change="{handleCheckboxChange}"
        >I understand that sensitive content will be filtered for public display.</Checkbox
      >
      <Button on:click="{handleConfirm}" hugged disabled="{isDisabled}">Got it</Button>
    </div>
  </Modal>
</Portal>
